import { render, staticRenderFns } from "./addCoursePackage.vue?vue&type=template&id=7a3555a7&scoped=true"
import script from "./addCoursePackage.vue?vue&type=script&lang=js"
export * from "./addCoursePackage.vue?vue&type=script&lang=js"
import style0 from "./addCoursePackage.vue?vue&type=style&index=0&id=7a3555a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3555a7",
  null
  
)

export default component.exports